import { Container } from 'react-bootstrap';
import PolaroidCard from 'thinktodo-polaroid';

export default function SkillContainer({projects}) {
	let windowFeatures = "popup";
	const { title, image, stacks, desc, link } = projects; 
	return(	
	<Container>	 
       <PolaroidCard 
       		containerClass='bg-white p-4 overflow-hidden mb-3'
	   		  rotate={'8'}
	   		  zoom={'1.1'}
	   		  width='120px'
	   		  height='fit-content'
	   		  imgSrc={image}
	   		  imgWidth='100%'
	   		  imgHeight={null}
	   		  imgClass='img-thumbnail border-0'
	   		  onClick={() => {
	   		  	window.open(link, windowFeatures);
	   		  }}
	   		  body={
	   		  	<>
	   		  	<h4 clasName="text-center" id="projectTitle"> {title} </h4>
	   		  	<span id="projectSubTitle">stacks:</span>
	   		  	<span id="projectProperty"> {stacks} </span>
	   		  	<br/>
	   		  	<span id="projectSubTitle">description:</span>
	   		  	<span id="projectProperty"> {desc} </span>
	   		  	</>
	   		  }	
       />
    </Container>
	);
}; 